(function () {
  var BULLET_PREFIX = /^[\u0007\u2022\u2023\u2043\u2219\u25AA\u25CF\u25E6•\-\*–—]\s*(.+)$/;
  var LABEL_PATTERN = /^(details|product\s+details|product\s+description)\s*:?\s*$/i;
  var SUBHEADING_PATTERN = /^(package includes|care instructions?|what'?s included|fabric|composition)\s*:?\s*$/i;
  var PRODUCT_CODE_PATTERN = /^[A-Z0-9][A-Z0-9\-\s]{2,}[A-Z0-9]$/;

  function cleanText(text) {
    return (text || '')
      .replace(/\u0007/g, '')
      .replace(/\uFFFD/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function stripGoogleAiMarkup(container) {
    container.querySelectorAll('[jscontroller], [data-sfc-cp], [data-ved], [data-hveid], [data-sfc-root]').forEach(function (el) {
      var text = cleanText(el.textContent);
      if (!text) {
        el.remove();
        return;
      }

      var replacement = document.createElement('p');
      replacement.textContent = text.replace(BULLET_PREFIX, '$1').trim();
      el.replaceWith(replacement);
    });

    container.querySelectorAll('div').forEach(function (div) {
      if (!div.textContent.trim() && div.children.length === 0) {
        div.remove();
      }
    });
  }

  function removeEmptyNodes(container) {
    container.querySelectorAll('p, li, span').forEach(function (node) {
      var text = cleanText(node.textContent);
      if (!text || text === '•' || text === 'Details:') {
        if (node.tagName === 'LI' && node.parentElement && node.parentElement.children.length === 1) {
          node.parentElement.remove();
        } else if (node.tagName !== 'SPAN' || !node.children.length) {
          node.remove();
        }
      }
    });
  }

  function normalizeExistingLists(container) {
    container.querySelectorAll('ul').forEach(function (list) {
      list.classList.add('noksha-details-list');
      list.querySelectorAll('li').forEach(function (item) {
        item.textContent = cleanText(item.textContent);
      });
    });
  }

  function wrapOrphanListItems(container) {
    var orphanItems = Array.prototype.slice.call(container.children).filter(function (el) {
      return el.tagName === 'LI';
    });

    if (!orphanItems.length) return;

    var list = document.createElement('ul');
    list.className = 'noksha-details-list';
    orphanItems[0].parentNode.insertBefore(list, orphanItems[0]);
    orphanItems.forEach(function (item) {
      item.textContent = cleanText(item.textContent);
      list.appendChild(item);
    });
  }

  function convertParagraphBullets(container) {
    var paragraphs = Array.prototype.slice.call(container.querySelectorAll('p'));
    var list = null;

    paragraphs.forEach(function (paragraph) {
      var text = cleanText(paragraph.textContent);

      if (!text) {
        paragraph.remove();
        return;
      }

      if (LABEL_PATTERN.test(text)) {
        paragraph.remove();
        list = null;
        return;
      }

      if (SUBHEADING_PATTERN.test(text)) {
        paragraph.className = 'noksha-details-subheading';
        list = null;
        return;
      }

      if (PRODUCT_CODE_PATTERN.test(text) && text.length < 30) {
        paragraph.className = 'noksha-details-code';
        list = null;
        return;
      }

      var bulletMatch = text.match(BULLET_PREFIX);
      if (bulletMatch) {
        if (!list) {
          list = document.createElement('ul');
          list.className = 'noksha-details-list';
          paragraph.parentNode.insertBefore(list, paragraph);
        }
        var item = document.createElement('li');
        item.textContent = bulletMatch[1];
        list.appendChild(item);
        paragraph.remove();
        return;
      }

      list = null;

      if (paragraph.querySelector('strong') && paragraph.children.length === 1) {
        paragraph.classList.add('noksha-details-line');
      }
    });
  }

  function formatShirtDetailBlocks(container) {
    container.querySelectorAll('p').forEach(function (paragraph) {
      var html = paragraph.innerHTML;
      if (!/shirt detail|trouser detail|dupatta detail|front|back|sleeves/i.test(html)) return;

      paragraph.classList.add('noksha-details-spec');
      paragraph.querySelectorAll('strong').forEach(function (strong) {
        strong.classList.add('noksha-details-spec__label');
      });
    });
  }

  function formatDescription(container) {
    if (!container || container.dataset.nokshaFormatted === 'true') return;

    stripGoogleAiMarkup(container);
    removeEmptyNodes(container);
    normalizeExistingLists(container);
    wrapOrphanListItems(container);
    convertParagraphBullets(container);
    formatShirtDetailBlocks(container);
    removeEmptyNodes(container);

    container.dataset.nokshaFormatted = 'true';
  }

  function init() {
    document.querySelectorAll('[data-noksha-format-description]').forEach(formatDescription);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
